<nav class="text-white p-4 mb-4 bg-backgroundDark">
  <span class="glow"></span>
  <span class="glow2"></span>
  <img
    src="assets/images/logo2.png"
    alt="Logo"
    class="logo w-48 h-auto mx-auto"
  />
  <div class="space-y-4">
    <h3
      style="
        color: #fff;
        font-size: 0.85rem;
        margin-top: 15px;
        margin-bottom: 2px;
        font-weight: 500;
        letter-spacing: 0.5px;
      "
    >
      Búsqueda Global
    </h3>
    <!-- Dummy element to catch auto-focus from MatSidenav -->
    <button tabindex="0" class="sr-only">
      <span class="sr-only">Focus trap</span>
    </button>
    <app-input-search
      (searchClick)="openSearchModal()"
      (focusin)="openSearchModal()"
      [readonly]="true"
      [tabindex]="-1"
    ></app-input-search>
    <div
      class="flex items-center justify-center gap-1.5 mt-2 text-xs text-gray-400"
    >
      <kbd
        class="inline-flex items-center justify-center min-w-[24px] h-[22px] px-1.5 bg-[#2d2d30] border border-white/20 rounded text-[11px] text-[#e0e0e0] text-center shadow-[0_1px_0_rgba(255,255,255,0.1),0_1px_3px_rgba(0,0,0,0.3)]"
        >Ctrl</kbd
      >
      <span>+</span>
      <kbd
        class="inline-flex items-center justify-center min-w-[24px] h-[22px] px-1.5 bg-[#2d2d30] border border-white/20 rounded text-[11px] text-[#e0e0e0] text-center shadow-[0_1px_0_rgba(255,255,255,0.1),0_1px_3px_rgba(0,0,0,0.3)]"
        >K</kbd
      >
      <span class="ml-1">para buscar</span>
    </div>

    @if (showSearchModal) {
      <app-search-modal (closeEvent)="closeSearchModal()"></app-search-modal>
    }

    <app-tarjetas-sidebar></app-tarjetas-sidebar>
    <app-close-section-button></app-close-section-button>
  </div>
</nav>
